/** @file profilePitchToggle: the orientation cube's centre click, between the profile pitch and the last one. */

/** The pitch to set and the pitch to remember for the next click (null: nothing to go back to). */
export type PitchToggle = { pitchDeg: number; saved: number | null };

/**
 * Away from the profile pitch: go to it and remember the current pitch. At the profile pitch: go back to the
 * remembered one (and forget it), or stay when there is none.
 */
export function profilePitchToggle(currentDeg: number, profileDeg: number, saved: number | null): PitchToggle {
  if (currentDeg !== profileDeg) return { pitchDeg: profileDeg, saved: currentDeg };
  return saved === null ? { pitchDeg: profileDeg, saved: null } : { pitchDeg: saved, saved: null };
}
